export default "__VITE_ASSET__L7mFfmxe__"